import React from 'react'
import './sidebar.css'
import TopLogo from '../Parcial/TopLogo'
import Clock from '../Parcial/Clock'
import Logout from '../Parcial/Logout'
import Navigtion from '../Parcial/Navigtion'
import Create from '../Parcial/Create'
import EmailFilters from '../Parcial/EmailFilters'
import SideBrEmailMob from '../Parcial/SideBrEmailMob'
import Utils from '../Parcial/Utils'


function SideBarEmail() {
  return (
    <>
    <div className='sideBar'>
      <div className="sideBar2">
        <TopLogo />
        <Navigtion />
        
        <Create />
        <EmailFilters />
        <Utils />
        <Clock />
        <Logout />
        </div>
    </div>
    <div className="sideBarMob">
      <SideBrEmailMob />
    </div>
    </>
  )
}

export default SideBarEmail